class QuestionnaireApi {
    async createQuestionnaire(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/create`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getQuestionnaires(accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    async getQuestionnairesByFormationId(formationId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires?formation_id=${formationId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return json.data || [];
    }

    async updateQuestionnaire(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/update`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async deleteQuestionnaire(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/delete`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getQuestionnaireById(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/${id}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getSessionsByFormationId(formationId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/load-custom-report-selected-formation-data/${formationId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return json.sessions || [];
    }
    async getQuestions(questionnaireId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/${questionnaireId}/questions`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async createQuestion(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questions/create`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async updateQuestion(values, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questions/update`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(values),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async deleteQuestion(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questions/delete`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async sendByEmail(id, accessToken, formationId = null, sessionId = null) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/send`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id, formation_id: formationId, session_id: sessionId }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async duplicateQuestionnaire(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/duplicate`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async fetchPublic(id, learnerId, tenant, sessionId = null) {
        let URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/public/${id}?learner_id=${learnerId}`;
        if (tenant) {
            URL += `&tenant=${tenant}`;
        }
        if (sessionId) {
            URL += `&session_id=${sessionId}`;
        }
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await resp.json();
    }

    async submitQuestionnaire(payload, tenant) {
        let URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submit`;
        if (tenant) {
            URL += `?tenant=${tenant}`;
        }
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return await resp.json();
    }
    async fetchSubmissions(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/${id}/submissions`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    /**
     * Vue d'ensemble « Suivi des réponses » : une ligne agrégée par session.
     * `filters` accepte formation_id, session_id, year, format, profession, search.
     * `withOptions` ramène en plus les valeurs disponibles des listes déroulantes
     * (à ne demander qu'au changement de type de questionnaire).
     */
    async fetchSubmissionsOverview(type, filters, accessToken, withOptions = false, signal = undefined) {
        const params = new URLSearchParams({ type });
        Object.entries(filters || {}).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '' && value !== 'All') {
                params.append(key, value);
            }
        });
        if (withOptions) params.append('with_options', '1');

        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/overview?${params.toString()}`;
        const resp = await fetch(URL, {
            method: 'GET',
            signal,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /**
     * Détail paginé des réponses (avec le JSON des réponses) pour le tiroir de session.
     */
    async fetchSubmissionsDetail(type, filters, accessToken, page = 1, perPage = 50, signal = undefined) {
        const params = new URLSearchParams({ type, page, per_page: perPage });
        Object.entries(filters || {}).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '' && value !== 'All') {
                params.append(key, value);
            }
        });

        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/detail?${params.toString()}`;
        const resp = await fetch(URL, {
            method: 'GET',
            signal,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /**
     * Importe les questionnaires d'une session depuis un CSV.
     *
     * Le fichier part en texte dans le corps JSON : il pèse quelques
     * kilo-octets, et cela évite une route qui accepte des pièces jointes.
     *
     * @param {Object} payload { csv, formation_id, session_id }
     * @param {string} accessToken
     * @returns {Promise<Object>} status, message, errors[], data[]
     */
    async importQuestionnaires(payload, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/import`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return resp.json();
    }

    /**
     * Inscrits et questions d'une session, pour pré-remplir le modèle CSV.
     *
     * @param {number} sessionId
     * @param {string} accessToken
     * @returns {Promise<Object>} { learners: [], questions: [] }
     */
    async getAnswersTemplate(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/answers/template/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        const json = await resp.json();
        return { learners: (json && json.learners) || [], questions: (json && json.questions) || [] };
    }

    /**
     * Importe les réponses d'une session depuis un CSV.
     *
     * @param {Object} payload { csv, session_id }
     * @param {string} accessToken
     * @returns {Promise<Object>} status, message, errors[], warnings[], data[]
     */
    async importAnswers(payload, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/answers/import`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return resp.json();
    }

    async fetchSubmissionsByFilter(type, formationId, sessionId, accessToken, year) {
        let URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/filter?type=${type}`;
        if (formationId) URL += `&formation_id=${formationId}`;
        if (sessionId) URL += `&session_id=${sessionId}`;
        if (year && year !== 'All') URL += `&year=${encodeURIComponent(year)}`;
        
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    /**
     * Moyennes Pré/Post toutes formations actives confondues : la synthèse
     * affichée par l'écran Progression quand aucune formation n'est choisie.
     * Agrégé côté serveur, la réponse tient en quelques octets.
     */
    async getProgressionGlobalSummary(accessToken, year) {
        const suffixe = year && year !== 'All' ? `?year=${encodeURIComponent(year)}` : '';
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/progression/global-summary${suffixe}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async deleteSubmission(id, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/delete`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ id }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getSatisfactionSummaryBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/submissions/session-summary/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
    async getGlobalFormationsSatisfactionSummary(accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/satisfaction/formations-summary`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getResponsesTrackingBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/responses-tracking/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /**
     * Relance d'un apprenant sur les seuls questionnaires qu'il n'a pas remplis.
     * `dryRun` compose sans envoyer : c'est ce qu'affiche le dialogue de
     * confirmation avant que l'e-mail ne parte.
     */
    async missingQuestionnaires(sessionId, customerId, accessToken, dryRun = false) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/missing/${dryRun ? 'plan' : 'send'}`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ sessionID: sessionId, customerID: customerId }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    /**
     * Même relance, pour toute la session : `dryRun` compose la liste des
     * apprenants concernés sans rien envoyer.
     */
    async missingQuestionnairesForSession(sessionId, accessToken, dryRun = false) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/missing/session/${dryRun ? 'plan' : 'send'}`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ sessionID: sessionId }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getQuestionnairesStatusBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/session-status/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async getCompletionCandidatesBySession(sessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/completion-candidates/${sessionId}`;
        const resp = await fetch(URL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }

    async createMissingQuestionnairesFromSession(targetSessionId, sourceSessionId, accessToken) {
        const URL = `${process.env.REACT_APP_API_URL}/api/questionnaires/create-missing-from-session`;
        const resp = await fetch(URL, {
            method: 'POST',
            body: JSON.stringify({ targetSessionId, sourceSessionId }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        });
        return await resp.json();
    }
}

export const questionnaireApi = new QuestionnaireApi();
